import React from "react";
import {
  Dumbbell, Brain, Heart, Flame, Sparkles, Leaf, Mountain,
  Sun, Moon, Zap, Shield, Target, Upload
} from "lucide-react";
import { Button } from "./ui/button";
import { API } from "../App";

export const ICON_MAP = {
  dumbbell: Dumbbell, brain: Brain, heart: Heart, flame: Flame,
  sparkles: Sparkles, leaf: Leaf, mountain: Mountain, sun: Sun,
  moon: Moon, zap: Zap, shield: Shield, target: Target,
};

export const FITNESS_GOALS = [
  { id: "build_strength", label: "Build Strength", icon: Dumbbell },
  { id: "improve_focus", label: "Improve Focus", icon: Brain },
  { id: "reduce_stress", label: "Reduce Stress", icon: Heart },
  { id: "boost_energy", label: "Boost Energy", icon: Zap },
  { id: "increase_flexibility", label: "Flexibility", icon: Leaf },
  { id: "better_sleep", label: "Better Sleep", icon: Moon },
  { id: "overall_wellness", label: "Overall Wellness", icon: Sparkles },
];

export const AvatarDisplay = ({ profile, size = "w-20 h-20", textSize = "text-3xl" }) => {
  if (profile?.avatar_type === "preset" && profile?.avatar_preset) {
    const IconComp = ICON_MAP[profile.avatar_preset.icon] || Sparkles;
    return (
      <div className={`${size} rounded-full bg-gradient-to-br ${profile.avatar_preset.bg} flex items-center justify-center shadow-lg`}>
        <IconComp className="w-1/2 h-1/2 text-white" strokeWidth={1.5} />
      </div>
    );
  }
  if (profile?.picture) {
    const src = profile.picture.startsWith("/api") 
      ? `${API.replace('/api', '')}${profile.picture}` 
      : profile.picture;
    return <img src={src} alt="" className={`${size} rounded-full object-cover shadow-lg`} />;
  }
  return (
    <div className={`${size} rounded-full bg-gradient-to-br from-sky-400 to-indigo-400 flex items-center justify-center shadow-lg`}>
      <span className={`${textSize} text-white`}>{profile?.name?.[0] || "?"}</span>
    </div>
  );
};

export const AvatarPicker = ({ avatars, profile, onSelect, onUpload, onCancel }) => (
  <div className="bg-white/60 rounded-xl p-4 border border-sky-100 mb-4 animate-in slide-in-from-top-2 duration-200" data-testid="avatar-picker">
    <h4 className="text-sm font-medium text-sky-700 mb-3">Choose an avatar</h4>
    <div className="grid grid-cols-6 gap-2 mb-4">
      {avatars.map((av) => {
        const IconComp = ICON_MAP[av.icon] || Sparkles;
        return (
          <button
            key={av.id}
            onClick={() => onSelect(av.id)}
            className={`aspect-square rounded-xl bg-gradient-to-br ${av.bg} flex items-center justify-center hover:scale-110 transition-transform ${
              profile?.avatar_preset?.id === av.id ? "ring-2 ring-sky-500 ring-offset-2" : ""
            }`}
            data-testid={`avatar-${av.id}`}
          >
            <IconComp className="w-5 h-5 text-white" strokeWidth={1.5} />
          </button>
        );
      })}
    </div>
    <div className="flex items-center gap-3">
      <label className="flex items-center gap-2 cursor-pointer text-sm text-sky-600 hover:text-sky-800 transition-colors">
        <Upload className="w-4 h-4" />
        Upload custom photo
        <input type="file" accept="image/*" className="hidden" onChange={onUpload} data-testid="photo-upload-input" />
      </label>
      <Button variant="ghost" size="sm" onClick={onCancel}>Cancel</Button>
    </div>
  </div>
);
